'use strict'

/**
 * Module Wishlist
 */

import ajaxManagement from 'Modules/ajaxManagement'
import gestionLocalStorage from 'Modules/gestionLocalStorage'
import { SupprimerArticleWishListInLocalStorage } from 'Modules/gestionLocalStorage'
import modal from 'Modules/modal'
import inscriptionModule from 'Modules/inscriptionModule'
import inscriptionConnexionCustomAction from 'Modules/inscriptionConnexionCustomAction'

const URL_DELETE_ITEM = '/WishList/SupprimerArticle'
const URL_ADD_ITEM = '/WishList/AjouterWishListArticle'
const URL_GET_WISHLIST = '/WishList/GetArticles'

const KEY_LOCALSTORAGE_WISHLIST = 'articleswishlist'

let addHandler = null
let removeHandler = null

/**
 * Mets à jour le HTML qui affiche le nombre d'éléments dans la wishlist dans le header
 * @param {number} compte Nombre d'éléments dans la wishlist
 */
export function UpdateWishListCountHeader(compte) {
    let html = ''

    if (compte > 0) {
        html = compte
    }

    if (compte >= 100) {
        html = '+99'
    }

    $('.nbWishList').html(html)

    // Ajoute la classe CSS qui mets le fond rose derrière le nombre.
    // Si le compte est égal à 0, on l'enlève
    if (!$('.nbWishList').hasClass('isinwishlist')) {
        $('.nbWishList').addClass('isinwishlist')
        $('.nbWishList').css('display', 'block')
    } else if ($('.nbWishList').hasClass('isinwishlist') && compte === 0) {
        $('.nbWishList').removeClass('isinwishlist')
        $('.nbWishList').css('display', 'none')
    }
}

/**
 * Ajoute ou supprime un élément à la wishlist dans la BDD.
 * Si l'utilisateur n'est pas connecté, on affiche la modal de connexion
 * @param {HTMLElement} item Element HTML
 * @param {string} codeTaille Code taille
 */
export function ManageItemInWishlist(item, codeTaille) {
    if (item.attr('data-id') === undefined) {
        item.addClass('is-wishlist')

        const data = {
            cc: item.data('couleur'),
            rm: item.data('refmodele'),
            ct: codeTaille
        }

        $.ajax({
            url: URL_ADD_ITEM,
            data: data,
            success: function (data) {
                item.attr('data-id', data.item.id)
                item.addClass('is-wishlist')

                UpdateWishListCountHeader(data.cpt)
                gestionLocalStorage.ajouterArticleWishList(data.item)

                if (data.TagScripts !== undefined && data.TagScripts != '') {
                    try {
                        eval(data.TagScripts)
                    } catch (error) {
                        console.error(error)
                    }
                }

                if (addHandler != null) {
                    addHandler()
                }
            },
            error: function (xhr) {
                item.removeClass('is-wishlist')

                if (xhr.status == 403) {
                    modal.creer(
                        'modalInscription',
                        'j_modal_wishlist_catalogue modal-connexion poppin-newconnexion in',
                        window.location.origin +
                            '/Inscription/ModalConnexionInscription/',
                        initModalConnexionInscription
                    )

                    ajaxManagement.SaveLastCall(
                        URL_ADD_ITEM,
                        data,
                        function (data) {
                            item.attr('data-id', data.item.id)
                            item.addClass('is-wishlist')

                            UpdateWishListCountHeader(data.cpt)
                            gestionLocalStorage.ajouterArticleWishList(
                                data.item
                            )

                            if (addHandler != null) {
                                addHandler()
                            }
                        }
                    )
                }
            }
        })
    } else {
        const dataSend = {
            id: item.data('id')
        }

        $.ajax({
            url: URL_DELETE_ITEM,
            data: dataSend,
            error: function (xhr, ajaxOptions, thrownError) {
                if (xhr.status == 401) {
                    ajaxManagement.SaveLastCall(
                        URL_DELETE_ITEM,
                        dataSend,
                        function (data) {
                            item.removeAttr('data-id')

                            UpdateWishListCountHeader(data.cpt)
                            SupprimerArticleWishListInLocalStorage(dataSend.id)

                            item.removeClass('is-wishlist')

                            if (removeHandler != null) {
                                removeHandler()
                            }
                        }
                    )

                    // window.location.href = URL_INSCRIPTION;
                    $('.j_modal_wishlist_catalogue').modal({
                        keyboard: true,
                        show: true
                    })
                }
            },

            success: function (data) {
                item.removeAttr('data-id')

                UpdateWishListCountHeader(data.cpt)
                SupprimerArticleWishListInLocalStorage(dataSend.id)

                item.removeClass('is-wishlist')

                if (removeHandler != null) {
                    removeHandler()
                }
            }
        })
    }
}

/**
 * Récupère la wishlist dans le localstorage. Sinon fait un appel API
 */
export function GetWishList() {
    // Récupère la wishlist dans le local storage
    const wishlist = localStorage.getItem(KEY_LOCALSTORAGE_WISHLIST)

    if (wishlist !== null) {
        return new Promise(function (resolve) {
            resolve(JSON.parse(wishlist))
        })
    }

    const requestOptions = {
        method: 'GET'
    }

    return fetch(URL_GET_WISHLIST, requestOptions)
        .then(function (response) {
            return response.json()
        })
        .then(function (data) {
            try {
                localStorage.setItem(
                    KEY_LOCALSTORAGE_WISHLIST,
                    JSON.stringify(data)
                )
            } catch (QuotaExceededError) {
                //TODO Gestion du LocalStorage plein
            } finally {
                return data
            }
        })
}

function ajouterArticleWishList(refModele, couleur, taille, callback) {
    window.WishListCallback = callback

    const url = '/WishList/AjouterWishListArticle'

    const headers = new Headers({
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    })

    const requestOptions = {
        method: 'GET',
        headers: headers
    }

    const formData = {
        rm: refModele,
        cc: couleur,
        ct: taille
    }

    const params = '?' + $.param(formData)

    return fetch(url + params, requestOptions).then(function (response) {
        if (response.status == 403) {
            modal.creer(
                'modalInscription',
                'j_modal_wishlist_catalogue modal-connexion poppin-newconnexion in',
                window.location.origin +
                    '/Inscription/ModalConnexionInscription/',
                initModalConnexionInscription
            )

            ajaxManagement.SaveLastCall(
                url,
                formData,
                ajouterArticleWishListOnsuccess
            )
        } else {
            response.json().then((json) => {
                ajouterArticleWishListOnsuccess(json)
            })
        }
    })
}

function ajouterArticleWishListOnsuccess(data) {
    GetWishList().then(function (wishlist) {
        wishlist.push(data.item)
        try {
            localStorage.setItem(
                KEY_LOCALSTORAGE_WISHLIST,
                JSON.stringify(wishlist)
            )
        } catch (QuotaExceededError) {
            //TODO Gestion du LocalStorage plein
        } finally {
            UpdateWishListCountHeader(data.cpt)
            afficheWishlistCatalogue()

            if (window.WishListCallback !== undefined) {
                window.WishListCallback()
            }
        }
    })
}

/**
 * Supprime un article dans la wishlist
 * @param {string} id Id du produit
 */
export function SupprimerArticleWishList(id) {
    const url = '/WishList/SupprimerArticle'

    const requestOptions = {
        method: 'GET'
    }

    const formData = {
        id: id
    }

    const params = '?' + $.param(formData)

    return fetch(url + params, requestOptions)
        .then(function (response) {
            return response.json()
        })
        .then(function (data) {
            localStorage.removeItem(KEY_LOCALSTORAGE_WISHLIST)

            const item = $(".wishListItem[data-id='" + id + "']")

            item.removeAttr('data-id')
            item.removeClass('is-wishlist')

            UpdateWishListCountHeader(data.cpt)

            afficheWishlistCatalogue()
        })
}

function afficheWishlistCatalogue() {
    GetWishList().then(function (wishlist) {
        wishlist.forEach(function (article, index) {
            let item = $(
                ".wishListItem[data-refmodele='" +
                    article.RefModele +
                    "'][data-couleur='" +
                    article.CodeCouleur +
                    "']"
            )
            if (item !== undefined && item.length > 0) {
                item.data('id', article.Id)
                item.attr('data-id', article.Id)
                item.addClass('is-wishlist')
            }

            item = $(
                ".wishListItem-sim[data-refmodele='" +
                    article.RefModele +
                    "'][data-couleur='" +
                    article.CodeCouleur +
                    "']"
            )
            if (item !== undefined && item.length > 0) {
                item.data('id', article.Id)
                item.attr('data-id', article.Id)
                item.addClass('is-wishlist')
            }
        })
    })
}

function initModalConnexionInscription() {
    inscriptionModule.Process()

    $('#passwordPerdu').click(function () {
        modal.creer(
            'modalMotdepassePerdu',
            'fade m-password-forgotten modal-pass-forgot in',
            window.location.origin + '/Inscription/ModalMotdepassePerdu/',
            initModalMotdepassePerdu
        )
    })
}

function initModalMotdepassePerdu() {
    const J_PASSWORD_FORGOTTEN_FORM_ID = '.j-pwdForgotten'
    const J_PASSWORD_FORGOTTEN_ID = '.modal-pass-forgot'

    import('Modules/bootstrapValidationForm').then(
        (bootstrapValidationForm) => {
            bootstrapValidationForm.default.initModalForm(
                J_PASSWORD_FORGOTTEN_ID,
                J_PASSWORD_FORGOTTEN_FORM_ID,
                inscriptionConnexionCustomAction.recoverPassword
            )
        }
    )
}

export default {
    ajouterArticleWishList: ajouterArticleWishList
}
